import React from 'react';
import '../../styles/admin/ReportSummary.css';

const ReportSummary = ({ reportData }) => {
  const cards = [
    {
      title: 'Total Revenue',
      value: `LKR ${reportData.totalRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      icon: 'fas fa-dollar-sign',
      color: '#10b981',
      bgColor: '#d1fae5'
    },
    {
      title: 'Total Invoices',
      value: reportData.totalInvoices,
      icon: 'fas fa-receipt',
      color: '#8b5cf6',
      bgColor: '#ede9fe'
    },
    {
      title: 'Average Order Value',
      value: `LKR ${reportData.averageOrderValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      icon: 'fas fa-chart-bar',
      color: '#f59e0b',
      bgColor: '#fef3c7'
    }
  ];

  return (
    <div className="report-summary-cards">
      {cards.map((card, index) => (
        <div key={index} className="summary-card" style={{ borderColor: card.color }}>
          <div className="card-icon" style={{ backgroundColor: card.bgColor, color: card.color }}>
            <i className={card.icon}></i>
          </div>
          <div className="card-content">
            <h3>{card.title}</h3>
            <p className="card-value" style={{ color: card.color }}>{card.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReportSummary;